export type EventValidationInput = {
    name?: string | null;
    sport?: { id?: string | number | null } | null;
};

export function validateEventForSave(event: EventValidationInput): boolean {
    return Boolean(event.name?.trim()) && Boolean(event.sport?.id);
}
